import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators ,NgForm} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-assign-user-dialog',
  template: `
  <h3>{{data.head}}</h3>
    <hr>
    <p [innerHtml]="data.body.replace('##', data.item? '<strong>'+data.item+'</strong>': 'this item')"> </p>
    <div class="row a-center">

      <mat-form-field class="col-9" >
      <mat-label>{{data.head}}
      </mat-label>
      <mat-select formControlName="assignUser" multiple="!data.single" (valueChange)='handleChange($event)'>
        <mat-option *ngFor="let item of  data?.options" [value]="item">
          {{item.optionName}} </mat-option>
      </mat-select>
    </mat-form-field>

      <div class="col-3">
        <button mat-raised-button (click)="submit()" color="primary">Submit</button>
        <!-- <button mat-button (click)="onNoClick()" cdkFocusInitial class="ml-2">Cancel</button> -->
      </div>
    </div>
    <button class="close" mat-icon-button (click)="onNoClick()"><mat-icon>close</mat-icon></button>
    `,
  styles: ['.content-wrap{max-height:60vh;overflow-y:auto}',
    `:host{
      position: relative;
      display: block;
    }
    button.close{
      position:absolute;
      top:-10px;
      right:-10px;
    }`
  ]
})
export class AssignUserDialogComponent implements OnInit {

  assignUser = new FormControl([], Validators.required);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<AssignUserDialogComponent>) { }

  ngOnInit() {
    console.log('data',this.data);
    if (this.data.assigned?.length) {
      this.assignUser.setValue(this.data.assigned);
    }
  }

  submit() {  
    this.assignUser.setValue(this.ids);
    if (this.assignUser.valid) {
      this.dialogRef.close(this.assignUser.value);
    }
  }
  getArr = [];
  obj = {};
  ids;
  handleChange(event) {
    this.ids = event.map(item => {
      if (item) {
        return this.obj = { userId: item.userId, username: item.username }
      }
    });
  }
  

  onNoClick(): void {
    this.dialogRef.close();
  }
}
